
import { displayMessage } from "../../helpers/messages"


export default [
    {
        field: 'id',
        headerName: 'Código',
        width: 100

    },
    {
        field: 'name',
        headerName: displayMessage('COMPANY_NAME'),
        valueGetter: (params) => params?.row.name || '',
        width: 220
    },
    {
        field: 'cnpj',
        headerName: displayMessage('DOCUMENT'),
        flex: 1,
        valueGetter: (params) => params?.row.cnpj || ''
    },
    // {
    //     field: 'state',
    //     headerName: displayMessage('STATE'),
    //     width: 165,
    //     valueGetter: (params) => params?.row.active || ''
    // },
    // {
    //     field: 'segment',
    //     headerName: displayMessage('SEGMENT'),
    //     width: 165,
    //     valueGetter: (params) => params?.row.segment || ''
    // },
    // {
    //     field: 'users_count ',
    //     headerName: displayMessage('QUANTITY_OF_USERS'),
    //     valueGetter: (params) => params?.row.Users.length || 0,
    //     width: 165,
    // },
]